import React from 'react';
import SetPageTitle from 'components/Portals/SetPageTitle';
import SetPageNavAction from 'components/Portals/SetPageNavAction';

import { useTranslation } from 'services/localization';
import { Routes } from 'routing';

import Urls from './Urls';
import Domains from './Domains';
import { useHasFeature } from 'hooks';
import TabContainer from 'components/nav/TabContainer';
import Container from 'components/Container';

const DomainsRoot = () => {
	const { t } = useTranslation();
	const { hasFeature } = useHasFeature();

	return (
		<>
			<SetPageTitle priority={2} title={t('account.domains.domainsAndUrls', 'Domains & URLs')} />
			<SetPageNavAction
				priority={2}
				backAction={{ to: Routes.ACCOUNT, title: t('account.pageTitle', 'Account') }}
				quickLinks={[]}
			/>
			<Container>
				<TabContainer
					basePath={Routes.ACCOUNT_DOMAINS}
					tabs={[
						{
							label: t('account.domains.urls', 'Urls'),
							path: 'urls',
							component: Urls,
						},
						{
							label: t('account.domains.pageTitle'),
							path: 'domains',
							component: Domains,
							locked: !hasFeature('CUSTOM_DOMAINS', { scope: 'shop' }),
							hidden: !hasFeature('CUSTOM_DOMAINS', { scope: 'user' }),
						},
					]}
					defaultTab="urls"
				/>
			</Container>
		</>
	);
};

export default DomainsRoot;
